export function publicAsset(path: string) {
  if (/^https:\/\//i.test(path)) return path

  const base = import.meta.env.BASE_URL || '/'
  const normalizedBase = base.endsWith('/') ? base : `${base}/`
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path

  return `${normalizedBase}${normalizedPath}`
}

export const brandLogo = publicAsset('images/brand/Logo%20telegrafo.svg')
export const brandLogoWhite = publicAsset('images/brand/Logo-et-horizontal-blanco.svg')
export const brandIsotype = publicAsset('images/brand/fav-et.svg')

export const footerSocialIcons = {
  facebook: publicAsset('icons/social/facebook.svg'),
  instagram: publicAsset('icons/social/instagram.svg'),
  tiktok: publicAsset('icons/social/tiktok.svg'),
  youtube: publicAsset('icons/social/youtube.svg'),
  x: publicAsset('icons/social/x.svg'),
} as const
